import { Flex, Spinner } from '@chakra-ui/react';
import { BluePrintTitle } from './Title';
import { BlueprintMetrics } from './Metrics';
import { BlueprintSteps } from './Steps';

import { useGetBluePrintQuery } from '@/store/query/blueprint';

export const BlueprintDetails = ({
  blueprint = {},
  onCreateFromBlueprint = () => {},
}) => {
  const { data: blueprintData, isFetching } = useGetBluePrintQuery(
    {
      blueprintId: blueprint?.id,
    },
    { skip: !blueprint }
  );

  if (isFetching) {
    return (
      <Flex
        height="calc(100% - 123px)"
        alignItems="center"
        justifyContent="center"
      >
        <Spinner color="#0043CE" />
      </Flex>
    );
  }

  return (
    <>
      <BluePrintTitle
        blueprint={blueprintData}
        onCreateFromBlueprint={onCreateFromBlueprint}
      />
      <BlueprintMetrics blueprint={blueprintData} />
      <BlueprintSteps
        blueprint={blueprintData}
        onCreateFromBlueprint={onCreateFromBlueprint}
      />
    </>
  );
};
